export default __webpack_public_path__ + "static/media/slideshow_1.d00fb5c0.jpg";